<template>
    <router-view></router-view>
      <!-- <router-view  v-slot="{ Component }">
        <keep-alive>
          <component :is="Component" :exclude="['ChangeModel', 'ModelParams']" />
        </keep-alive>
      </router-view> -->
</template>
<script>
export default {
  name: "ReportHome",
  components: {
  }
};
</script>